export const ORDER_EXCEPTION_DISPLAY_MAP: Record<string, string> = {
  "[Missing] Clinic Notes": "Missing Clinic Notes",
  "[Missing] Collection Date": "Missing Collection Date",
  "[Missing] High-risk Feature": "Missing SCC High-risk Feature",
  "[Missing] ICD-10": "Missing ICD-10 Code",
  "[Missing] MET Letter": "Missing MET Letter",
  "[Missing] MD SIG": "Missing Physician Signature",
  "[Missing] Pathology Report": "Missing Path Report",
  "[Missing] Patient Address": "Missing Patient Information",
  "[Missing] Patient DOB": "Missing Patient Information",
  "[Missing] Patient Insurance": "Missing Patient Insurance",
  "[Missing] UM Radiation Yes/No": "Missing Radiation Confirmation",
  "[Missing] Rationale Letter": "Missing Rationale Letter",
  "[Missing] Specimen ID": "Missing Specimen ID",
  "[Missing] Treatment Letter": "Missing Treatment Letter",
  "[Missing] COA/Reflex": "Missing COA/Reflex",
  "Pending COA Attestation": "Missing COA Attestation",
  "Pending Collection Facility": "Pending Sample Collection Facility Info",
  "Pending Eligibility Confirmation": "Pending Eligibility Confirmation",
  "Pending Endo Report": "Missing Endoscopy Report",
  "Pending MOHS report/notes": "Pending MOHS report/notes",
  "Pending Order Reinstatement Form":
    "Pending Completed Order Reinstate Form",
  "Pending Path Report (Excision)": "Missing Excision Path Report",
  "Pending Path Report (Primary)": "Missing Pathology Report",
  "Pending Patient Authorization": "Pending Patient Authorization",
  "[Unclear] Specimen ID": "Unclear Specimen ID - Need Confirmation",
};

export function getOrderExceptionBannerText(
  orderExceptions: string | null | undefined
): string | null {
  if (!orderExceptions || typeof orderExceptions !== "string") {
    return null;
  }

  const messages = orderExceptions
    .split(",")
    .map((value) => value.trim())
    .filter(Boolean)
    .map((key) => ORDER_EXCEPTION_DISPLAY_MAP[key] ?? key);

  if (messages.length === 0) {
    return null;
  }

  return messages.join(", ");
}
